import { ref } from 'vue'

const openMenu = ref(null)

export function useCardMenu() {
  const toggleMenu = type => {
    openMenu.value = openMenu.value === type ? null : type
  }

  const isMenuOpen = type => {
    return openMenu.value === type
  }

  const closeMenu = () => {
    openMenu.value = null
  }

  return {
    openMenu,
    toggleMenu,
    isMenuOpen,
    closeMenu,
  }
}
